'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _themeSections = require('@shopify/theme-sections');

var _slickCarousel = require('slick-carousel');

var _slickCarousel2 = _interopRequireDefault(_slickCarousel);

var _slick = require('../modules/slick');

var _slick2 = _interopRequireDefault(_slick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeSections.register)('blog-related', {
  onLoad: function onLoad() {
    var showRelatedItems = function () {
      var collection = (0, _jquery2.default)(this.container).find('[data-related-collection]');
      var limit = (0, _jquery2.default)(collection).data('collection-products');
      var limit_medium = (0, _jquery2.default)(collection).data('collection-products-medium');
      var limit_small = (0, _jquery2.default)(collection).data('collection-products-small');

      var settings = (0, _slick2.default)({
        slidesToShow: limit,
        slidesToScroll: limit,
        appendArrows: (0, _jquery2.default)(this.container).find('.slick-arrows'),
        arrows: true,
        responsive: [{
          breakpoint: Breakpoints['large'],
          settings: {
            slidesToShow: limit_medium,
            slidesToScroll: limit_medium
          }
        }, {
          breakpoint: Breakpoints['small'],
          settings: {
            slidesToShow: limit_small,
            slidesToScroll: limit_small
          }
        }]
      });

      collection.slick(settings);
      var trigger = new Event('lazy:reload');
      document.dispatchEvent(trigger);
    }.bind(this);
    showRelatedItems();
  },

  /**
  * Event callback for Theme Editor `section:unload` event
  */
  onUnload: function onUnload() {}
});